<template>
    <div class="bg-gray-700 relative pt-1 flex flex-col items-center justify-end">
        <div class="transition duration-500 ease-in-out w-full px-1 mb-1">
            <transition name="slide">
                <div v-show="showDropzone">
                    <transition name="slide">
                        <div v-show="!isUploading && form.media.length<10">
                            <vue-dropzone
                                v-show="!isSending"
                                ref="myVueDropzone"
                                :useCustomSlot="true"
                                id="dropzone"
                                :url="getUrl"
                                :options="dropzoneOptions"
                                @vdropzone-error="showDropzoneError"
                                @vdropzone-error-multiple="showDropzoneError"
                                @vdropzone-file-added="fileAdded"
                                @vdropzone-max-files-exceeded="removeFile">
                                <div class="dropzone-container">
                                    <div class="file-selector font-bold text-indigo-400 pt-3">
                                        <button type="button" class="outline-none">Drop here or click to browse</button>
                                    </div>
                                </div>
                            </vue-dropzone>
                        </div>
                    </transition>
                    <div class="text-white font-bold bg-white" id="preview">
                        <div class="flex flex-wrap p-2" v-if="form.media.length>0 && !isUploading">
                            <div class="font-bold text-center text-black w-full">{{ isSending ? "Sending..." : "Selected Files" }}</div>
                            <div v-if="!isSending" class="px-2 w-full" v-for="file in form.media">
                                <div class="flex justify-between items-center border-gray-200 border rounded-lg p-1 my-1">
                                    <div class="flex items-center">
                                        <div class="text-indigo-400 mr-2">
                                            <!-- Upload Icon -->
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                                                </path>
                                            </svg>
                                        </div>
                                        <div class="text-gray-700 truncate text-sm font-medium">{{ file.name }}</div>
                                    </div>
                                    <button @click="removeFile(file,false)" class="dz-remove outline-none">
                                        <span class="text-gray-300">
                                            <!-- X Icon -->
                                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd"
                                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                      clip-rule="evenodd"></path>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--<div v-if="isUploading" class="py-2">
                            <div class="loader"></div>
                            <div class="text-center text-black font-bold pt-2">Uploading Files: {{ fileUploadProgress }}%</div>
                        </div>-->
                    </div>
                </div>
            </transition>
        </div>
        <div class="w-full" id="message-input-section">
            <div class="text-xs py-2 rounded-lg bg-gray-600 text-gray-300 mx-1 px-2" v-if="reply !== null">
                <div class="flex justify-between pb-1">
                    <div class="font-bold" v-if="!reply.is_message_by_authenticated_user">{{ reply.sender_name }}</div>
                    <div class="font-bold" v-if="reply.is_message_by_authenticated_user">You</div>
                    <button
                        class="outline-none -mt-1 -mr-1 text-gray-300"
                        @click="()=>{this.reply=null; this.form.reply_id=null;}">

                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </button>
                </div>
                <div>
                    {{ reply.message === null ? "Media only message with " + reply.media.length + " uploads" : reply.message }}
                </div>
            </div>
            <div class="flex pb-1">
                <div class="flex flex-col" :class="showShareExistingMediaButton ? 'justify-between py-1' : 'justify-around py-3 '">
                    <emoji-picker :search="search">
                        <div
                            class="-mb-1 outline-none"
                            slot="emoji-invoker"
                            slot-scope="{ events: { click: clickEvent } }"
                            @click="clickEvent">
                            <button @click="search=''" class="pl-3 pr-1 outline-none text-white">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </button>
                        </div>
                        <div slot="emoji-picker" slot-scope="{ emojis }">
                            <div class="absolute z-10 border h-64 overflow-y-scroll rounded bg-white shadow left-0 right-0"
                                 :style="getBottomOffsetForEmojiPopup">
                                <div class="flex sticky top-0 p-1 bg-white">
                                    <input class="rounded-lg border py-2 px-4 outline-none focus:ring w-full" type="text" v-model="search"
                                           placeholder="Search Emojis">
                                </div>
                                <div class="p-3">
                                    <div v-for="(emojiGroup, category) in emojis" :key="category">
                                        <h5 class="text-grey-darker uppercase text-sm cursor-default mb-2 mt-4">{{ category }}</h5>
                                        <div class="flex flex-wrap emojis text-lg">
                                            <button
                                                class="p-1 cursor-pointer rounded hover:bg-grey-light focus:outline-none focus:ring flex items-center justify-center h-8 w-8"
                                                v-for="(emoji, emojiName) in emojiGroup"
                                                :key="emojiName"
                                                @click="insertEmoji(emoji)"
                                                :title="emojiName">
                                                {{ emoji }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </emoji-picker>
                    <button v-if="showAttachmentsUploadButton" class="outline-none text-white pl-3 pr-1"
                            @click="showDropzone = !showDropzone"
                            :disabled="isUploading">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
                        </svg>
                    </button>
                    <button v-if="showShareExistingMediaButton" class="outline-none text-white pl-3 pr-1"
                            @click="openExistingMediaModal"
                            :disabled="isUploading">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                        </svg>
                    </button>
                </div>
                <textarea id="message-box"
                          class="text-sm flex-1 mx-2 my-1 px-2 py-1 rounded-md overflow-y-auto outline-none"
                          style="min-height: 5.80rem; max-height: 25rem;"
                          rows="4"
                          placeholder="Type Message Here..."
                          :value="form.message"
                          @input="input=> form.message = input.target.value"
                          @keydown.shift="shiftPressed">
                </textarea>
                <div class="relative flex flex-col justify-around pt-1 pr-3 pl-1 items-center text-center">
                    <button class="outline-none text-white " @click.prevent="sendMessage"
                            :disabled="isSending || isUploading">
                        <svg class="w-6 h-6 transform rotate-45 ml-2 mb-2" :class="{'pulse' : isSending}" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                        </svg>
                    </button>
                    <span class="absolute right-2 bottom-0 left-0 text-gray-300" :class="wordCounter < 0 ? 'text-red-600' : 'text-gray-300'">
                        {{ wordCounter }}
                    </span>
                </div>
            </div>
            <multi-upload-component ref="multiUploadComponent1"
                                    v-if="multiUploadUrl"
                                    :show="showMultiUploadModal"
                                    :media-url="multiUploadUrl"
                                    :model-typ="modelType"
                                    :sending="isSending"
                                    :messenger-channel-id="channel.id"
                                    :full-width="true"
                                    @media-selected="attachSelectedMedia"
                                    @close-modal="closeMultiAttachmentModal">
            </multi-upload-component>
        </div>
    </div>
</template>

<script>
import "../../../css/messaging.css";
import EmojiPicker from "vue-emoji-picker";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    name: "MessageInput",

    components: {
        EmojiPicker,
        vueDropzone: vue2Dropzone,
    },

    props: {
        channel: {
            type: Object,
            required: true,
        },
        showAttachmentsUploadButton: {
            required: false,
            default: true,
        },
        showShareExistingMediaButton: {
            required: false,
            default: true
        }
    },

    data () {
        return {
            isUploading: false,
            isSending: false,
            fileUploadProgress: 0,

            form: new AppForm({
                message: "",
                type: null,
                reply_id: null,
                media: []
            }),

            reply: null,
            search: "",
            showDropzone: false,

            showMultiUploadModal: false,
            attachmentLimit: 10,
            wordCounter: 2500,
        };
    },

    watch: {
        "form.message" () {
            if (this.form.message.length > 2500) {
                this.form.message = this.form.message.substr(0, 2500);
            }
            this.wordCounter = 2500 - this.form.message.length;
        }
    },

    created () {
        let self = this;

        Bus.$on("reply-selected", function (message) {
            self.replySelected(message);
        });
    },

    computed: {
        dropzoneOptions () {
            return {
                url: "/files/validate", //dummy endpoint required by dropZone when not using s3
                maxFilesize: 25,
                headers: {"X-CSRF-TOKEN": window.axios.defaults.headers.common["X-CSRF-TOKEN"]},
                includeStyling: true,
                previewsContainer: false,
                addRemoveLinks: false,
                autoProcessQueue: false,
                uploadMultiple: false,
                maxFiles: 1000,
                parallelUploads: 11
            };
        },

        multiUploadUrl () {
            return "/attachments/multi/" + this.channel.model_type.replace("App\\", "").toLowerCase() + "/" + this.channel.model_id;
        },

        getBottomOffsetForEmojiPopup () {
            let bottomOffset = document.getElementById("message-box").offsetHeight + 15;

            return {
                "bottom": `${bottomOffset}px`
            };
        },

        modelType () {
            return this.channel?.model_type;
        }
    },

    methods: {
        insertEmoji (emoji) {
            this.form.message += emoji;
        },

        shiftPressed (event) {
            if (event.code === "Enter" && event.shiftKey) {
                this.sendMessage();
            }
        },

        openExistingMediaModal () {
            this.form.media = [];
            this.showMultiUploadModal = true;
        },

        resetInput () {
            this.form = new AppForm({
                message: "",
                type: null,
                reply_id: null,
                media: []
            });

            this.reply = null;
            this.showDropzone = false;
            this.wordCounter = 3000;
        },

        sendMessage () {
            if (this.isSending) {
                // Prevent duplicate messages
                return;
            }

            this.form.type = this.form.media.length > 0 ? "media" : "text";
            this.isSending = true;

            if (this.form.type === "text" && _.trim(this.form.message) === "") {
                this.isSending = false;
                this.isUploading = false;
            } else {
                // This syntax is used to select the appropriate method on the App class dynamically
                // This will translate to App.postMultipartForm("/messages"....etc) for example
                App[this.form.type === "media" ? "postMultipartForm" : "post"](`/messenger/channels/${this.channel.id}/messages/create`, this.form)
                .then((response) => {
                    this.closeMultiAttachmentModal();
                    if (this.form.type === "media") {
                        if (this.$refs.multiUploadComponent1) {
                            this.$refs.multiUploadComponent1.clearMediaSelection();
                        }
                    }
                    this.$emit("message-sent", response);
                    Bus.$emit("update-own-list", response);
                    this.isUploading = false;
                    this.resetInput();
                    this.isSending = false;
                })
                .catch((error) => {
                    this.$set(this, "isSending", false);
                    this.$set(this, "isUploading", false);
                    toastr.error("Unable to send message! " + error.message);
                });
            }
        },

        /*
        The following methods are used to send media messages through the dropzone FormData object
        Some of these methods are hooked into the events emitted by the DropZone component,
        where others are triggered when the send button is pressed.
        */
        addFileToMessageForm (file) {
            if (file) {
                this.form.media.push(file);
            }
        },

        fileAdded (file) {

            let attachment = {};
            attachment.uuid = file.upload.uuid;
            attachment.name = file.name;
            attachment.progress = 0;
            attachment.type = file.type;
            attachment.size = file.size;
            attachment.source = file;
            attachment.from_existing_media = false;

            if (this.form.media.length >= this.attachmentLimit) {
                toastr.error("File limit reached! Only 10 uploads per message allowed");
            } else {
                this.form.media.push(attachment);
            }
        },

        removeFile (file, requestFromDropzone = true) {

            if (requestFromDropzone) {
                this.$refs.myVueDropzone.removeFile(file);
            } else {
                this.$refs.myVueDropzone.removeFile(file.source);

                let index = this.form.media.indexOf(file);
                if (index > -1) {
                    this.form.media.splice(index, 1);
                    toastr.success("File removed!");
                }
            }
        },

        openMultiAttachmentModal () {
            this.showMultiUploadModal = true;
        },

        closeMultiAttachmentModal () {
            this.showMultiUploadModal = false;
        },

        attachSelectedMedia (selectedAttachments) {
            selectedAttachments.forEach((attachment) => {
                if (this.form.media.length < this.attachmentLimit) {
                    attachment.from_existing_media = true;
                    this.form.media.push(attachment);
                } else {
                    toastr.error("File limit reached! Only 10 uploads per message allowed");
                    return null;
                }
            });

            this.sendMessage();
        },

        // This method is required by DropZone even though the url is not really used.
        getUrl (files) {
            return "/files/validate";
        },

        showDropzoneError (files, message, xhr,) {
            // Temporary Workaround to prevent toast for Cancelled which happens
            // because we are not uploading to S3 anymore.
            // TODO # figure out how to prevent this event from firing
            if (message !== "Upload canceled.") {
                toastr.error(message);
            }
        },

        handleCancel () {
            return null;
        },

        replySelected (message) {
            this.form.reply_id = message.id;
            this.reply = message;

            if (this.reply.message === "") {
                this.reply.message = "Media only message with " + this.reply.media.length + " attachments";
            }
            document.getElementById("message-box").focus();
        },
    },
};
</script>

<style scoped>
.pulse {
    fill: white;
    fill-opacity: 0;
    transform-origin: 50% 50%;
    animation-duration: 1s;
    animation-name: pulse;
    animation-iteration-count: infinite;
}

@keyframes pulse {
    0% {
        stroke-width: 2px;
        stroke-opacity: 1;
        transform: scale(0.2);
    }
    50% {
        stroke-width: 1px;
        stroke-opacity: .2;
        transform: scale(2.5);
    }
    100% {
        stroke-width: 2px;
        stroke-opacity: 1;
        transform: scale(0.2);
    }
}
</style>
